var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 100,
    viewBox: "0 0 98 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 3C37.1 3 47 12.9 47 25C47 37.1 37.1 47 25 47C12.9 47 3 37.1 3 25C3 12.9 12.8 3 25 3ZM25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0Z",
    transform: "translate(48 50)",
    fill: "#007EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10001 4.2C3.2598 4.2 4.2 3.2598 4.2 2.1C4.2 0.9402 3.2598 0 2.10001 0C0.940208 0 0 0.9402 0 2.1C0 3.2598 0.940208 4.2 2.10001 4.2Z",
    transform: "translate(70.8999 72.9)",
    fill: "#FBAC1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12.8",
    transform: "translate(73 57)",
    stroke: "#FBAC1F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0H0",
    transform: "translate(78.1001 75)",
    stroke: "#FBAC1F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.7L1.7 0",
    transform: "translate(90.1001 56.2)",
    stroke: "#007EE5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V5.7",
    transform: "translate(73 45)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.10001",
    transform: "translate(69.4004 45)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 4.4C3.41502 4.4 4.4 3.41502 4.4 2.2C4.4 0.98497 3.41502 0 2.2 0C0.98497 0 0 0.98497 0 2.2C0 3.41502 0.98497 4.4 2.2 4.4Z",
    transform: "translate(33.6006 46.9)",
    fill: "#007EE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5787 3.2L71.4787 25.6L16.0787 57.6L3.1787 35.2L58.5787 3.2ZM58.7787 0C58.3787 0 57.9787 0.1 57.5787 0.3L1.1787 32.9C0.0787029 33.6 -0.321299 35 0.278701 36.2L13.7787 59.6C14.1787 60.4 14.9787 60.8 15.8787 60.8C16.2787 60.8 16.6787 60.7 17.0787 60.5L73.5787 27.9C74.6787 27.2 75.0787 25.8 74.4787 24.6L60.8787 1.2C60.4787 0.4 59.6787 0 58.7787 0Z",
    transform: "translate(17.7217)",
    fill: "#007EE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 4.4C3.41502 4.4 4.4 3.41503 4.4 2.2C4.4 0.984973 3.41502 0 2.2 0C0.98497 0 0 0.984973 0 2.2C0 3.41503 0.98497 4.4 2.2 4.4Z",
    transform: "translate(72.1006 9.5)",
    fill: "#007EE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 13.6C10.5555 13.6 13.6 10.5555 13.6 6.8C13.6 3.04446 10.5555 0 6.8 0C3.04446 0 0 3.04446 0 6.8C0 10.5555 3.04446 13.6 6.8 13.6Z",
    transform: "translate(48.7002 24.4)",
    stroke: "#007EE5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3039 2.6L2.20387 7.3C1.60387 7.7 0.703867 7.5 0.403867 6.8L0.203867 6.5C-0.196133 5.9 0.00386721 5 0.703867 4.7L8.80387 0L10.3039 2.6Z",
    transform: "translate(5.29639 35.7)",
    fill: "url(#paint0_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7039 2.6L2.20387 12.7C1.60387 13.1 0.703867 12.9 0.403867 12.2L0.203867 12C-0.196133 11.4 0.00386721 10.5 0.703867 10.2L18.2039 0L19.7039 2.6Z",
    transform: "translate(0.696289 44)",
    fill: "url(#paint1_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9039 2.6L2.20387 9.4C1.60387 9.8 0.703867 9.6 0.403867 8.9L0.203867 8.7C-0.196133 8.1 0.00386721 7.2 0.703867 6.9L12.4039 0L13.9039 2.6Z",
    transform: "translate(11.2964 52.3)",
    fill: "url(#paint2_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3039 2.6L2.20387 7.3C1.60387 7.7 0.703866 7.5 0.403866 6.8L0.203867 6.5C-0.196133 5.9 0.00386721 5 0.703867 4.7L8.80387 0L10.3039 2.6Z",
    transform: "translate(19.6963 60.6)",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.0078328 -1.42375) scale(10.3033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0038672 -3.38935) scale(19.6947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.0218328 -2.1506) scale(13.9234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0012672 -1.36645) scale(10.3033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.b5bc7476281ddc1be141bec2b980eba7.svg";
export { ForwardRef as ReactComponent };